import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";

import { ItemService } from "core/items/items.service";

@Component({
	selector: "item-type-select",
	templateUrl: "./item-type-select.component.html",
})
export class ItemTypeSelectComponent implements OnInit {
	@Input() queryParam: string;

	@Output() change: EventEmitter<any> = new EventEmitter();

	options: any[] = [];

	constructor(private itemService: ItemService) {}

	ngOnInit() {
		this.itemService.itemTypesAsOptions().then((options: any[]) => {
			this.options = options;
		});
	}

	setSelection(option: any) {
		this.change.emit(option);
	}
}
